export const reducerCases = {
    SET_TOKEN : "SET_TOKEN",
    SET_PLAYLISTS: "SET_PLAYLISTS",
    SET_USERS: "SET_USERS",
    SET_PLAYING:"SET_PLAYING",
    SET_SCREEN:"SET_SCREEN",
    SET_SONGSLIST : "SET_SONGSLIST",
    SET_TRACKLIST : "SET_TRACKLIST",
    SET_ALBUMLIST : "SET_ALBUMLIST",
    SET_ARTISTLIST : "SET_ARTISTLIST",
    SET_CATEGORIES : "SET_CATEGORIES",
    SET_FEATURED : "SET_FEATURED",
    SET_NEWALBUMS : "SET_NEWALBUMS",
    SET_PLAYLISTID: "SET_PLAYLISTID",
    SET_ALBUMID: "SET_ALBUMID",
    SET_ALBUMTRACKS : "SET_ALBUMTRACKS",
    SET_ALBUMDETAILS : "SET_ALBUMDETAILS",
    SET_FEATUREDID : "SET_FEATUREDID",
    SET_SELECTEDID : "SET_SELECTEDID",
    SET_PLAYSTATE : "SET_PLAYSTATE",
} 